import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "../link";
// import { useTheme } from "styles";
import { useLocation } from "@reach/router";

const Wrapper = styled(Link)`
  padding: 20px;
  font-size: 2em;
  z-index: 520;
  display: flex;
  white-space: nowrap;
  .letsTalk {
    display: inline-block;
    padding: 10px;
    color: white;
    font-size: 0.7em;
    font-weight: 300;
    @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
      font-size: 1em;
    }
  }
  .circle {
    color: black;
    background: white;
    border-radius: 100px;
    display: inline-block;
    font-size: 0.7em;
    padding: 9px 13px;
    @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
      font-size: 0.9em;
      padding: 9px 14px;
    }
    font-weight: 300;
  }
`;

// const circleMotion = ;

const LetsTalk: React.FC<Props> = ({ text, text2 }) => {
  const path = useLocation().pathname;
  const animate = (path === "/contact") ? "rest" : "rest";
  const rest = (path === "/contact") ? "hover" : "rest";
  const to = (path === "/contact") ? "#contact" : "/contact";
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    <Wrapper to={to}>
      <motion.div
        initial={rest}
        whileHover="hover"
        animate={animate}
        whileTap="tap"
      >
        <div className="letsTalk">{text || "Let's talk"}</div>
        <motion.div className="circle" variants={{
            rest: {
              scale: 1,
              backgroundColor: "#fff",
              color: "#000",
            },
            hover: {
              scale: 1.1,
              backgroundColor: "#F67E7D",
              color: "#fff",
            },
            tap: {
              rotate: -45,
              transition: {
                duration: 0.4,
                type: "tween",
                ease: "easeOut",
              },
            },
          }}>
          {text2 || "hi!"}
        </motion.div>
      </motion.div>
    </Wrapper>
  );
};

export { LetsTalk };


export interface Props {
  text?: string;
  text2?: string;
  contact: boolean;
}
